'use strict';
var promise1 = new Promise(function(resolve, reject) {
    var logo = document.querySelector('.logo');
    logo.addEventListener('click', function(e) {
        resolve();
    });
});
promise1.then(function() {
    return showMessage('Promise was resolved!', 'message');
}).catch(function() {
    return showMessage('Promise was rejected!', 'message error-message');
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error('Timeout error'));
    }, 3000);
});
promise2.then(function() {
    return showMessage('Promise was resolved!', 'message');
}).catch(function() {
    return showMessage('Promise was rejected!', 'message error-message');
});
function showMessage(text, className) {
    var newDiv = document.createElement('div');
    newDiv.className = className;
    newDiv.textContent = text;
    document.body.append(newDiv);
}

//# sourceMappingURL=js_promise_basic_DOM.add1654d.js.map
